export default __webpack_public_path__ + "static/media/640_business05-es-web.e48927d1.png";